"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _formTemplateHelper = require("../../../../helpers/formTemplateHelper");
var _formValidations = require("../../../../helpers/formValidations");
var _withdrawHelper = require("../../../../helpers/withdrawHelper");
var _WithdrawWorkflowsContainer = _interopRequireDefault(require("../../../WithdrawSidePaneComponents/WithdrawWorkflows/WithdrawWorkflowsContainer"));
var _VerificationRequiredContainer = _interopRequireDefault(require("../../../VerificationRequired/VerificationRequiredContainer"));
var _Spinner = _interopRequireDefault(require("../../../common/Spinner/Spinner"));
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _APNumberInput = _interopRequireDefault(require("../../../common/APNumberInput"));
var _APSelect = _interopRequireDefault(require("../../../common/APSelect"));
var _classnames = _interopRequireDefault(require("classnames"));
var _config = _interopRequireDefault(require("../../../../config"));
require("./FiatWithdrawFormComponent.css");
var _SendFiatTransfer = _interopRequireDefault(require("../../../SendFiatTransfer/SendFiatTransfer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-withdraw-form');
var slidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-slide-pane');
var FiatWithdrawFormComponent = /*#__PURE__*/function (_React$Component) {
  function FiatWithdrawFormComponent() {
    var _this;
    _classCallCheck(this, FiatWithdrawFormComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FiatWithdrawFormComponent, [].concat(args));
    _defineProperty(_this, "state", {
      isTransfer: false
    });
    _defineProperty(_this, "lessThanBalance", function (value) {
      var t = _this.props.t;
      var balance = _this.props.balance;
      if (balance === 0) return t('0 balance available');
      return (0, _formValidations.lessThanValue)(balance, value);
    });
    _defineProperty(_this, "toggleTransfer", function () {
      if (_config["default"].global.allowTransfer) {
        _this.setState({
          isTransfer: !_this.state.isTransfer
        });
      }
    });
    return _this;
  }
  _inherits(FiatWithdrawFormComponent, _React$Component);
  return _createClass(FiatWithdrawFormComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        product = _this$props.product,
        selectWithdrawProduct = _this$props.selectWithdrawProduct,
        selectPosition = _this$props.selectPosition,
        initialize = _this$props.initialize;
      selectPosition(product.ProductId);
      selectWithdrawProduct(product.ProductId);
      initialize(_objectSpread({}, product));
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        handleSubmit = _this$props2.handleSubmit,
        disableWithdraw = _this$props2.disableWithdraw,
        withdrawInfo = _this$props2.withdrawInfo,
        _this$props2$withdraw = _this$props2.withdrawInfo,
        withdrawWorkflowInfo = _this$props2$withdraw.withdrawWorkflowInfo,
        template = _this$props2$withdraw.template,
        templateTypes = _this$props2$withdraw.templateTypes,
        isLoading = _this$props2$withdraw.isLoading,
        error = _this$props2$withdraw.error,
        product = _this$props2.product,
        _this$props2$product = _this$props2.product,
        ProductSymbol = _this$props2$product.ProductSymbol,
        ProductId = _this$props2$product.ProductId,
        balance = _this$props2.balance,
        fee = _this$props2.fee,
        total = _this$props2.total,
        showDetails = _this$props2.showDetails,
        verificationOnClick = _this$props2.verificationOnClick,
        selectWithdrawTemplate = _this$props2.selectWithdrawTemplate,
        allowTransfer = _this$props2.allowTransfer,
        invalid = _this$props2.invalid;
      var showTemplateTypeSelect = (0, _withdrawHelper.showTemplateSelect)(withdrawInfo);
      var useExternalWithdrawWorkflow = withdrawWorkflowInfo && Object.values(withdrawWorkflowInfo).length;
      var hasTemplateType = withdrawWorkflowInfo && Object.values(templateTypes).length;
      var templateTypeOptions = [{
        value: '',
        label: 'Select an option'
      }].concat(_toConsumableArray(templateTypes.map(function (template) {
        return {
          value: template.AccountProviderId,
          label: template[_config["default"].Withdraw.AccountProviderDisplayKey]
        };
      })));
      var DecimalPlaces = this.props.products.decimalPlaces[product.ProductSymbol];
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
        className: baseClasses('send-to')
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: baseClasses('source')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('source-item-with-border')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('source-item', {
          selected: !this.state.isTransfer
        }),
        onClick: this.toggleTransfer
      }, t('External Account'))), allowTransfer && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('source-item', {
          selected: this.state.isTransfer
        }),
        onClick: this.toggleTransfer
      }, t('Send Transfer')))), this.state.isTransfer ? /*#__PURE__*/_react["default"].createElement(_SendFiatTransfer["default"], {
        onChange: this.props.onChange,
        balance: balance
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_WithdrawWorkflowsContainer["default"], null), /*#__PURE__*/_react["default"].createElement("form", {
        className: (0, _classnames["default"])(slidePaneClasses('body'), baseClasses('body')),
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-body')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('frame-container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('frame')
      }, disableWithdraw ? /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], {
        disabled: disableWithdraw,
        onClick: verificationOnClick
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showTemplateTypeSelect && /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "TemplateType",
        customClass: baseClasses(),
        label: t('Select an option to continue the withdraw process'),
        onSelect: function onSelect(value) {
          return selectWithdrawTemplate(ProductId, value);
        },
        options: templateTypeOptions
      }), !showTemplateTypeSelect && !Object.prototype.hasOwnProperty.call(template, 'Amount') && /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
        type: "text",
        name: "Amount",
        labelInInput: ProductSymbol,
        label: t('Amount of {{symbol}} to Withdraw', {
          symbol: ProductSymbol
        }),
        decimalPlaces: DecimalPlaces,
        customClass: baseClasses(),
        validate: [_formValidations.required, _formValidations.greaterThanZero, this.lessThanBalance]
      }), !useExternalWithdrawWorkflow && (0, _formTemplateHelper.templateFormRenderer)(template, baseClasses(''), {
        t: t
      }, product), !showDetails ? /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('info-items')
      }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Current Balance:'),
        text: "".concat(balance, " ").concat(ProductSymbol),
        customClass: baseClasses()
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Transaction Fee:'),
        text: fee !== undefined ? fee : '-',
        customClass: baseClasses()
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Final Balance:'),
        text: total !== undefined ? total : '-',
        customClass: baseClasses()
      })) : null, error && /*#__PURE__*/_react["default"].createElement("p", {
        className: baseClasses('error')
      }, t(error)), isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        customClass: baseClasses
      })))), !showTemplateTypeSelect && !disableWithdraw && !useExternalWithdrawWorkflow && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('footer')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: baseClasses(),
        disabled: disableWithdraw || invalid || !hasTemplateType,
        type: "submit",
        styleName: "additive"
      }, t('Withdraw'), " ", ProductSymbol))))));
    }
  }]);
}(_react["default"].Component);
FiatWithdrawFormComponent.defaultProps = {
  withdrawInfo: {
    template: {},
    isLoading: false,
    error: '',
    withdrawWorkflowInfo: [],
    withdrawStatus: {}
  }
};
FiatWithdrawFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  showSnack: _propTypes["default"].func,
  withdrawInfo: _propTypes["default"].shape({
    template: _propTypes["default"].object.isRequired,
    isLoading: _propTypes["default"].bool.isRequired,
    error: _propTypes["default"].string,
    product: _propTypes["default"].number,
    withdrawWorkflowInfo: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]).isRequired,
    withdrawStatus: _propTypes["default"].shape({
      success: _propTypes["default"].bool,
      RequestCode: _propTypes["default"].string
    }).isRequired
  }),
  disableWithdraw: _propTypes["default"].bool,
  verificationOnClick: _propTypes["default"].func,
  invalid: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('core')(FiatWithdrawFormComponent);